const isValidHttpUrl = (value) => {
	try {
		const parsed = new URL(value);
		return parsed.protocol === 'http:' || parsed.protocol === 'https:';
	} catch (e) {
		return false;
	}
};

const isIPv4 = (hostname) => {
	const parts = hostname.split('.');
	if (parts.length !== 4) {
		return false;
	}
	return parts.every((p) => {
		if (!/^\d{1,3}$/.test(p)) {
			return false;
		}
		const n = Number(p);
		return n >= 0 && n <= 255;
	});
};

export const isValidPageURL = (value) => {
	try {
		if (!isValidHttpUrl(value)) {
			return false;
		}

		const { hostname } = new URL(value);

		if (isIPv4(hostname)) {
			return true;
		}

		return hostname.includes('.');
	} catch (e) {
		return false;
	}
};
